<template>
  <Dropdown classMenuItems="md:w-[300px] top-[40px]" classItem="px-4 py-2">

    <template #open-state="{ open }">
      <div v-if="(isDropdownOpen = open)"></div>
    </template>

    <span
        class="relative h-[28px] w-[28px] lg:h-[28px] lg:w-[28px] lg:bg-gray-500-f7 bg-slate-50 text-slate-900 lg:dark:bg-slate-900 dark:text-white cursor-pointer rounded-full text-[20px] flex flex-col items-center justify-center">
    <Icon icon="heroicons-outline:bell" class="animate-tada"/>

    <span v-if="inboxStore.getUnreadMessagesCount"
          class="absolute lg:right-0 lg:top-0 -top-2 -right-2 h-4 w-4 bg-red-500 text-[8px] font-semibold flex flex-col items-center justify-center rounded-full text-white z-[99]">
      {{ inboxStore.getUnreadMessagesCount }}
    </span>
  </span>
    <template v-slot:menus>
      <div class="flex flex-col overflow-hidden max-h-[calc(100vh-60px)]">
        <div class="flex justify-between p-2 items-center border-b border-slate-600">
          <div class="text-sm text-slate-800 dark:text-slate-200 font-medium leading-6">
            Notifications
          </div>
          <div class="text-slate-200 text-xs text-right hover:text-blue-400">
            <router-link :to="{ name: 'Inbox' }" class="underline">
              View all
            </router-link>
          </div>
        </div>
        <template v-if="errorMessage">
          <div class="flex flex-row h-40 text-white items-center justify-center gap-2">
            <p>{{ errorMessage }}</p>
            <div @click="getAllInbox" class="cursor-pointer">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="lucide lucide-rotate-ccw-icon lucide-rotate-ccw">
                <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/>
                <path d="M3 3v5h5"/>
              </svg>
            </div>
          </div>
        </template>
        <template v-else>
          <div v-if="loading" class="flex items-center justify-center h-40">
            <Icon icon="eos-icons:bubble-loading" class="text-slate-300 size-6"/>
          </div>
          <div v-else-if="inboxStore.getMessages.length > 0"
               class="h-full divide-y divide-slate-700 overflow-y-auto custom-scrollbar">
            <MenuItem v-slot="{ active }" v-for="(message, i) in inboxStore.getMessages" :key="i">
              <div class="flex flex-col gap-2 p-2 text-white">
                <div class="flex flex-col gap-1">
                  <div class="flex flex-row justify-between">
                    <div class="text-xs text-slate-300">From: {{ message.senderName }}</div>
                    <p class="text-xs text-blue-200">
                      {{ gregorianDate(message.sendTime, 'DD MMM YYYY HH:mm') }}
                    </p>
                  </div>
                  <div class="grid grid-cols-[auto,1fr] gap-x-2">
                    <div class="col-start-1 col-end-2 flex items-center">
                      <!--if no notification-->
                      <div v-if="message.deliverTime" class="h-2 w-2"></div>
                      <!--if has notification -->
                      <div v-else class="h-2 w-2 rounded-full bg-red-500"></div>
                    </div>
                    <div class="col-start-2 col-end-3 text-sm">
                      {{ message.message }}
                    </div>
                    <!--                  <div class="col-start-2 col-end-3">
                                        <div>desc</div>
                                      </div>-->
                  </div>
                </div>
<!--                <div class="flex flex-row justify-between items-end">
                  <button class="text-sm text-slate-300 bg-blue-900 px-4 py-1 border border-slate-500 rounded-md">
                    read more
                  </button>
                  <div>

                  </div>
                </div>-->
              </div>
            </MenuItem>
          </div>
          <div v-else class="text-slate-400 text-sm h-40 flex items-center justify-center">There is no message.</div>
        </template>
      </div>
    </template>
  </Dropdown>
</template>
<script setup>
import Dropdown from "@/components/Dropdown/index.vue";
import {Icon} from "@iconify/vue";
import {MenuItem} from "@headlessui/vue";
import {onMounted, ref, computed, watch} from "vue";
import {useInboxStore} from "@/stores/inbox.js";
import {gregorianDate} from "@/utils/gregorianDate.js";
//import {getFCMToken} from "@/services/notification.js";

const inboxStore = useInboxStore();
const loading = ref(false)
const isDropdownOpen = ref(false)
let deliveryTimeout = null
const errorMessage = ref(null)

const setDelivery = async () => {
  if (inboxStore.getLastUnreadMessageID) {
    await inboxStore.action_setDelivery()

    setTimeout(async () => {
      await getAllInbox(false)
    }, 3000)
  }
}

watch(isDropdownOpen, (val) => {
  // dropdown opened
  if (val) {
    deliveryTimeout = setTimeout(() => {
      // check again because maybe dropdown closed meanwhile
      if (isDropdownOpen.value) {
        setDelivery()
      }
    }, 2000)
  }
  // dropdown closed
  else {
    if (deliveryTimeout) {
      clearTimeout(deliveryTimeout)
      deliveryTimeout = null
    }
  }
})
const getAllInbox = async (showLoading = true) => {
  if (showLoading) loading.value = true
  const res = await inboxStore.action_getAllInbox();
  if (res.result === true) {
    //await setDelivery();
  } else {
    errorMessage.value = res
  }
  loading.value = false
}

onMounted(() => {
  getAllInbox()
})
</script>
<style lang=""></style>
